import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';
import { createAction } from "redux-actions";

import { FlpHomeProgram } from '../api';

export const [
    fetchFlpHomeStaticContent,
    receiveFlpHomeStaticContent,
    flpHomeStaticContentError
  ] = createAsyncActions(
    'FLP_HOME_STATIC_TEXT',
    () => ({  }),
    ({ data }) => ({ data })
  );
  
export const getFlpHomeStaticContent = ( locale ) => {
  const fetchPromise = FlpHomeProgram.getFlpHomeStaticContent( locale );

  return runAsyncWorkflow({
      fetch: fetchFlpHomeStaticContent,
      receive: receiveFlpHomeStaticContent,
      error: flpHomeStaticContentError
    },fetchPromise)
};

export const [
  fetchFlpHomeGrades,
  receiveFlpHomeGrades,
  flpHomeGradesError
] = createAsyncActions(
  'FLP_HOME_GRADES',
  () => ({  }),
  ({ data }) => ({ data })
);

export const getFlpHomeGrades = ( locale, grade, supp, userId ) => {
const fetchPromise = FlpHomeProgram.getFlpHomeGrades( locale, grade,supp, userId );

return runAsyncWorkflow({
    fetch: fetchFlpHomeGrades,
    receive: receiveFlpHomeGrades,
    error: flpHomeGradesError
  },fetchPromise)
};

export const [
  fetchFlpHomeSimilarGrades,
  receiveFlpHomeSimilarGrades,
  flpHomeSimilarGradesError
] = createAsyncActions(
  'FLP_HOME_SIMILAR_GRADES',
  () => ({  }),
  ({ data }) => ({ data })
);

export const getFlpHomeSimilarGrades = ( locale, grade, supp ) => {
const fetchPromise = FlpHomeProgram.getFlpHomeGrades( locale, grade, supp );

return runAsyncWorkflow({
    fetch: fetchFlpHomeSimilarGrades,
    receive: receiveFlpHomeSimilarGrades,
    error: flpHomeSimilarGradesError
  },fetchPromise)
};

export const [
  fetchFlpHomeAboutContent,
  receiveFlpHomeAboutContent,
  flpHomeAboutContentError
] = createAsyncActions(
  'FLP_HOME_ABOUT_TEXT',
  () => ({  }),
  ({ data }) => ({ data })
);

export const  getFlpHomeAboutContent= ( locale ) => {
const fetchPromise = FlpHomeProgram.getFlpHomeAboutContent(locale);

return runAsyncWorkflow({
    fetch: fetchFlpHomeAboutContent,
    receive:  receiveFlpHomeAboutContent,
    error:  flpHomeAboutContentError
  },fetchPromise)
};

export const [
  fetchFlpHomeDownload,
  receiveFlpHomeDownload,
  flpHomeDownloadError
] = createAsyncActions(
  'FLP_HOME_DOWNLOAD',
  ({storyId, userId, locale}) => ({ storyId, userId, locale }),
  ({ ok, url, msg }) => ({ ok, url, msg })
);

export const flpHomeStoryDownload = ( storyId, userId, locale ) => {
const fetchPromise = FlpHomeProgram.flpHomeDownload(storyId, userId, locale);

return runAsyncWorkflow({
    fetch: fetchFlpHomeDownload,
    receive:  receiveFlpHomeDownload,
    error:  flpHomeDownloadError
  },fetchPromise)
};

export const [
  fetchGetResourceDetail,
  recieveGetResourceDetail,
  getResourceDetailError
] = createAsyncActions(
  'GET_RESOURCE_DETAIL',
  ({  bookId , locale  }) => ({  bookId , locale  }),
  ({ data }) => ({ data })
);

export const getFlpResourceDetail = ( bookId , locale, userId ) => {
  const fetchPromise = FlpHomeProgram.getResourceDetails( bookId , locale, userId );

  return runAsyncWorkflow({
    fetch: fetchGetResourceDetail,
    receive: recieveGetResourceDetail,
    error: getResourceDetailError
  }, fetchPromise)
}

export const [
  fetchFlpUserEnrolled,
  receiveFlpUserEnrolled,
  fetchFlpUserEnrolledError
] = createAsyncActions(
  'CHECK_FLP_USER_ENROLLED',
  ({ userId, locale , grade  }) => ({ userId, locale , grade }),
  ({ ok, data, grade }) => ({ isEnrolled: ok, data: data, grade })
);

export const checkFlpEnrollStatus = (userId, locale , grade) => {
  const fetchPromise = FlpHomeProgram.checkFlpUserEnrolled(userId, locale , grade);
  
  return runAsyncWorkflow({
    fetch: fetchFlpUserEnrolled,
    receive: receiveFlpUserEnrolled,
    error: fetchFlpUserEnrolledError
  }, fetchPromise, 
  { grade }
  );
};

export const [
  enrollFlpUserToLevel,
  receiveEnrollFlpUserToLevel,
  enrollFlpUserToLevelError
] = createAsyncActions(
  'ENROLL_FLP_USER_TO_LEVEL',
  ({ userId, locale,  grade}) => ({  userId, locale,  grade}),
  ({ ok }) => ({ enrolled: ok })
);

export const enrollFlpUser = (userId, locale,  grade, ps) => {
  const fetchPromise = FlpHomeProgram.enrollFlpUser( userId, locale,  grade, ps);
  
  return runAsyncWorkflow({
    fetch:  enrollFlpUserToLevel,
    receive: receiveEnrollFlpUserToLevel,
    error: enrollFlpUserToLevelError
  }, fetchPromise);
};

export const openFlpEnrolModal = createAction('OPEN_FLP_ENROL_FORM');
export const closeFlpEnrolModal = createAction('CLOSE_FLP_ENROL_FORM');

export const openBaselineModal = createAction('OPEN_BASELINE_FORM');
export const closeBaselineModal = createAction('CLOSE_BASELINE_FORM');

export const openPTModal = createAction('OPEN_PT_FORM');
export const closePTModal = createAction('CLOSE_PT_FORM');

export const openEndlineModal = createAction('OPEN_ENDLINE_FORM');
export const closeEndlineModal = createAction('CLOSE_ENDLINE_FORM');

export const openJotformModal = createAction('OPEN_JOTFORM_MODAL');
export const closeJotformModal = createAction('CLOSE_JOTFORM_MODAL');

export const selectFlpUserType = createAction('SELECT_FLP_USER_TYPE');

export const [
  setStoryStatus,
  receiveSetStoryStatus,
  setStoryStatusError
] = createAsyncActions(
  'SET_STORY_STATUS',
  ({ storyId, enrollmentId, themeId, status , locale }) => ({ storyId, enrollmentId, themeId, status , locale }),
  ({ data }) => ({ readStoryStatus: data })
);

export const flpSetStoryStatusFn = (storyId, enrollmentId, status , locale) => {
  const fetchPromise = FlpHomeProgram.setStoryStatus(storyId, enrollmentId, status , locale );
  
  return runAsyncWorkflow({
    fetch: setStoryStatus,
    receive: receiveSetStoryStatus,
    error: setStoryStatusError
  }, fetchPromise);
};

export const [
  fetchStoryStatus,
  receiveStoryStatus,
  fetchStoryStatusError
] = createAsyncActions(
  'CHECK_STORY_STATUS',
  ({ enrollmentId , locale , grade }) => ({ enrollmentId , locale , grade }),
  ({ data }) => ({ status: data.storiesStatus, label: data.reading_progress_text})
);

export const checkStoryStatus = (enrollmentId, locale , grade ) => {
  const fetchPromise = FlpHomeProgram.checkStoryStatus(enrollmentId, locale , grade );
  
  return runAsyncWorkflow({
    fetch: fetchStoryStatus,
    receive: receiveStoryStatus,
    error: fetchStoryStatusError
  }, fetchPromise);
};

export const [
  fetchNagCount,
  receiveNagCount,
  fetchNagCountError
] = createAsyncActions(
  'GET_NAG_COUNT',
  ({id, locale}) => ({id, locale}),
  ({ data }) => ({ readCount: data.read_count, enrolData: data.user_enrollment_data})
);

export const getNagCount = (id, locale) => {
  const fetchPromise = FlpHomeProgram.getNagCount(id, locale);
  
  return runAsyncWorkflow({
    fetch: fetchNagCount,
    receive: receiveNagCount,
    error: fetchNagCountError
  }, fetchPromise);
};

export const [
  fetchUpdateFlpHomeData,
  receiveUpdateFlpHomeData,
  fetchUpdateFlpHomeDataError
] = createAsyncActions(
  'UPDATE_FLP_HOME_DATA',
  ({id, details, locale}) => ({id, details, locale}),
  ({ data }) => ({ data})
);

export const updateFlpUserData  = (id, details, locale) => {
  const fetchPromise = FlpHomeProgram.updateFlpUserData(id, details, locale);
  
  return runAsyncWorkflow({
    fetch: fetchUpdateFlpHomeData,
    receive: receiveUpdateFlpHomeData,
    error: fetchUpdateFlpHomeDataError
  }, fetchPromise);
};

export const setFlpProgress = createAction('SET_FLP_PROGRESS');

export const [
  fetchFlpCertDownload,
  recieveFlpCertDownload,
  fetchFlpCertDownloadError
] = createAsyncActions(
  'GET_FLP_CERTIFICATE',
  ({ id, locale }) => ({ id, locale }),
  ({  ok, url, msg}) => ({  ok, url, msg})
);

export const getFlpCertificate =  (id, locale, name) => {
  const fetchPromise = FlpHomeProgram.getFlpCertificateData(id, locale, name);

  return runAsyncWorkflow({
    fetch: fetchFlpCertDownload,
    receive: recieveFlpCertDownload,
    error:   fetchFlpCertDownloadError
  }, fetchPromise)
}

export const [
  fetchFlpClassroomStaticContent,
  receiveFlpClassroomStaticContent,
  flpClassroomStaticContentError
] = createAsyncActions(
  'FLP_CLASSROOM_STATIC_TEXT',
  () => ({  }),
  ({ data }) => ({ data })
);

export const getFlpClassroomStaticContent = ( locale, userId ) => {
const fetchPromise = FlpHomeProgram.getFlpClassroomStaticContent( locale, userId );

return runAsyncWorkflow({
    fetch: fetchFlpClassroomStaticContent,
    receive: receiveFlpClassroomStaticContent,
    error: flpClassroomStaticContentError
  },fetchPromise)
};

export const [
  fetchFlpClassroomStudents,
  receiveFlpClassroomStudents,
  flpClassroomStudentsError
] = createAsyncActions(
  'FLP_CLASSROOM_GET_STUDENTS',
  () => ({  }),
  ({ data, error }) => ({ data, error })
);

export const getFlpClassroomStudents = ( locale, id, userId ) => {
const fetchPromise = FlpHomeProgram.getAllStudents( locale, id, userId );

return runAsyncWorkflow({
    fetch: fetchFlpClassroomStudents,
    receive: receiveFlpClassroomStudents,
    error: flpClassroomStudentsError
  },fetchPromise)
};

export const [
  fetchFlpValidateCode,
  receiveFlpValidateCode,
  FlpValidateCodeError
] = createAsyncActions(
  'FLP_VALID_CODE',
  () => ({  }),
  ({ status,valid, already_verified, state, locale }) => ({ status,valid, already_verified, state, locale })
);

export const getFlpValidateCode = (code, locale, id ) => {
const fetchPromise = FlpHomeProgram.getFlpValidateCode(code, locale, id );

return runAsyncWorkflow({
    fetch: fetchFlpValidateCode,
    receive: receiveFlpValidateCode,
    error: FlpValidateCodeError
  },fetchPromise)
};

export const [
  fetchFlpAddClassroom,
  receiveFlpAddClassroom,
  fetchFlpAddClassroomError
] = createAsyncActions(
  'FLP_ADD_CLASSROOM',
  () => {},
  ({data}) => ({data})
);

export const flpAddClassroomWorkflow = (data, userId, locale) => {
  const fetchPromise = FlpHomeProgram.flpAddClassroom(data, userId, locale)

  return runAsyncWorkflow({
    fetch: fetchFlpAddClassroom,
    receive: receiveFlpAddClassroom,
    error: fetchFlpAddClassroomError
  }, fetchPromise)
};

export const [
  fetchFlpAllClassroom,
  receiveFlpAllClassroom,
  flpAllClassroomError
] = createAsyncActions(
  'FLP_ALL_CLASSROOM',
  () => ({  }),
  ({ data }) => ({ data })
);

export const getFlpAllClassroom = ( locale, id ) => {
const fetchPromise = FlpHomeProgram.getAllClassrooms( locale, id );

return runAsyncWorkflow({
    fetch: fetchFlpAllClassroom,
    receive: receiveFlpAllClassroom,
    error: flpAllClassroomError
  },fetchPromise)
};

export const [
  fetchFlpAddStudent,
  receiveFlpAddStudent,
  fetchFlpAddStudentError
] = createAsyncActions(
  'FLP_ADD_STUDENT',
  () => {},
  ({data}) => ({data})

);

export const flpAddStudentWorkflow = (name, id, locale, userId) => {
  const fetchPromise = FlpHomeProgram.flpAddStudent(name, id, locale, userId)

  return runAsyncWorkflow({
    fetch: fetchFlpAddStudent,
    receive: receiveFlpAddStudent,
    error: fetchFlpAddStudentError
  }, fetchPromise)
};


export const [
  fetchFlpUpdateStudent,
  receiveFlpUpdateStudent,
  fetchFlpUpdateStudentError
] = createAsyncActions(
  'FLP_UPDATE_STUDENT',
  () => {},
  ({data}) => ({data})
)

export const flpUpdateStudentWorkflow = (name, id, locale, userId) => {
  const fetchPromise = FlpHomeProgram.flpUpdateStudent(name, id, locale, userId)

  return runAsyncWorkflow({
    fetch: fetchFlpUpdateStudent,
    receive: receiveFlpUpdateStudent,
    error: fetchFlpUpdateStudentError
  }, fetchPromise)
}

export const [
  fetchFlpUpdateClassroom,
  receiveFlpUpdateClassroom,
  fetchFlpUpdateClassroomError
] = createAsyncActions(
  'FLP_UPDATE_CLASSROOM',
  () => {},
  ({data}) => ({data})
)

export const flpUpdateClassroom = (data, id, locale, userId) => {
  const fetchPromise = FlpHomeProgram.flpUpdateClassroom(data, id, locale, userId)

  return runAsyncWorkflow({
    fetch: fetchFlpUpdateClassroom,
    receive: receiveFlpUpdateClassroom,
    error: fetchFlpUpdateClassroomError
  }, fetchPromise)
}

export const [
  fetchAllFlpEnrollUser,
  receiveAllFlpEnrollUser,
  fetchAllFlpEnrollUserError
] = createAsyncActions(
  'ALL_FLP_ENROLL_USER',
  () => {},
  ({ok, data}) => ({ok, data})
)

export const getAllFlpEnrollUser = (userId, locale) => {
  const fetchPromise = FlpHomeProgram.getAllFlpEnrollUser(userId, locale)

  return runAsyncWorkflow({
    fetch: fetchAllFlpEnrollUser,
    receive: receiveAllFlpEnrollUser,
    error: fetchAllFlpEnrollUserError
  }, fetchPromise)
}

export const [
  fetchFlpAllStories,
  receiveFlpAllStories,
  fetchFlpAllStoriesError
] = createAsyncActions(
  'FLP_ALL_STORIES',
  ({ page, perPage }) => ({ page, perPage }),
  ({ ok , data }) => ({ data: data})
);

export const [
  fetchMoreFlpAllStories,
  receiveMoreFlpAllStories,
  fetchMoreFlpAllStoriesError
] = createAsyncActions(
  'FLP_MORE_ALL_STORIES',
  ({ page, perPage }) => ({ page, perPage }),
  ({ ok , data }) => ({ data: data})
);

export const getFlpAllStories = ( filters, locale, page, perPage ) => {
  const fetchingMore = page && page > 1;
  const fetchPromise = FlpHomeProgram.getFlpAllStories( filters, locale, page, perPage );

  return runAsyncWorkflow(
    {
      fetch: fetchingMore ? fetchMoreFlpAllStories : fetchFlpAllStories,
      receive: fetchingMore ? receiveMoreFlpAllStories : receiveFlpAllStories,
      error: fetchingMore ? fetchMoreFlpAllStoriesError : fetchFlpAllStoriesError
    },
    fetchPromise
  );
};

export const [
  fetchValidateWorksheet,
  receiveValidateWorksheet,
  fetchValidateWorksheetError
] = createAsyncActions(
  'VALIDATE_WORKSHEET',
  () => {},
  ({ ok , data, errors }) => ({ data: data, errors: errors})
);

export const validateWorksheet = ( id ) => {
  const fetchPromise = FlpHomeProgram.validateWorksheet( id);

  return runAsyncWorkflow(
    {
      fetch: fetchValidateWorksheet,
      receive: receiveValidateWorksheet,
      error: fetchValidateWorksheetError
    },
    fetchPromise
  );
};

export const [
  fetchAddWorksheetQuestions,
  receiveAddWorksheetQuestions,
  fetchAddWorksheetQuestionsError
] = createAsyncActions(
  'ADD_WORKSHEET_QUESTIONS',
  () => {},
  ({ ok , data }) => ({ data: data})
);

export const addWorksheetQuestions = ( id ) => {
  const fetchPromise = FlpHomeProgram.addWorksheetQuestions( id);

  return runAsyncWorkflow(
    {
      fetch: fetchAddWorksheetQuestions,
      receive: receiveAddWorksheetQuestions,
      error: fetchAddWorksheetQuestionsError
    },
    fetchPromise
  );
};

export const [
  fetchViewWorksheetQuestions,
  receiveViewWorksheetQuestions,
  fetchViewWorksheetQuestionsError
] = createAsyncActions(
  'VIEW_WORKSHEET_QUESTIONS',
  () => {},
  ({ ok , data }) => ({ data: data})
);

export const viewWorksheetQuestions = ( id ) => {
  const fetchPromise = FlpHomeProgram.viewWorksheetQuestions( id);

  return runAsyncWorkflow(
    {
      fetch: fetchViewWorksheetQuestions,
      receive: receiveViewWorksheetQuestions,
      error: fetchViewWorksheetQuestionsError
    },
    fetchPromise
  );
};

export const [
  fetchViewWorksheetAnswers,
  receiveViewWorksheetAnswers,
  fetchViewWorksheetAnswersError
] = createAsyncActions(
  'VIEW_WORKSHEET_ANSWERS',
  () => {},
  ({ ok , data }) => ({ ok: ok, data: data})
);

export const viewWorksheetAnswers = (submissionId, enrolId, storyId ) => {
  const fetchPromise = FlpHomeProgram.viewWorksheetAnswers(submissionId, enrolId, storyId);

  return runAsyncWorkflow(
    {
      fetch: fetchViewWorksheetAnswers,
      receive: receiveViewWorksheetAnswers,
      error: fetchViewWorksheetAnswersError
    },
    fetchPromise
  );
};

export const [
  fetchAllFlpEnrollments,
  receiveAllFlpEnrollments,
  fetchAllFlpEnrollmentsError
] = createAsyncActions(
  'ALL_FLP_ENROLLMENTS',
  () => {},
  ({ok, data}) => ({ok, data})
)

export const getAllFlpEnrollments = () => {
  const fetchPromise = FlpHomeProgram.getAllFlpEnrollments()

  return runAsyncWorkflow({
    fetch: fetchAllFlpEnrollments,
    receive: receiveAllFlpEnrollments,
    error: fetchAllFlpEnrollmentsError
  }, fetchPromise)
}

export const [
  fetchDeleteSubmissions,
  receiveDeleteSubmissions,
  fetchDeleteSubmissionsError
] = createAsyncActions(
  'DELETE_SUBMISSIONS',
  () => {},
  ({ ok , data }) => ({ ok, data})
);

export const deleteSubmissions = ( id ) => {
  const fetchPromise = FlpHomeProgram.deleteSubmissions(id);

  return runAsyncWorkflow(
    {
      fetch: fetchDeleteSubmissions,
      receive: receiveDeleteSubmissions,
      error: fetchDeleteSubmissionsError
    },
    fetchPromise
  );
};



// WEBPACK FOOTER //
// ./src/redux/flpHomeActions.js